import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";
import { ProcessoNums } from "@/views/procesos/ProcessoNums";
import axios from "axios";
import { ProductoAmazon } from "../dtos/productosAmazon/ProductoAmazon";
import cargandoModule from "@/store/modules/cargando-module";
class TiendaService {
    private API_URL: string = "https://tiendadevoluciones.es/wp-json/wc/v3/";
    private CONSUMER_KEY: string = "ck_3da90420abffeb6f9407b5d01d84fb2ce1c90909";
    private CONSUMER_SECRET: string = "cs_11d9cf7eb0b5b3b8728ec15d7f550ad1e9517d54";

    public categorias: any[] = [];





    async crearProducto(caja: any, categoria_seleccionada: Array<{ id: number; name: string }>): Promise<void> {
        const url = this.API_URL + "products";
        const localizador = caja.localizador;
        const pesoTotal = parseFloat(caja.peso_caja.replace('kg', '').trim());
        var texto_caja = "Caja de devoluciones Amazon " + localizador;
        var pallet = false;
        if (pesoTotal > 50) {
            texto_caja = "Pallet de devoluciones Amazon " + localizador;
            pallet = true;
        }


        await TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacion({ skip: 0, take: 60000, selectedProcessoNumber: ProcessoNums.Disponible, search: localizador });
 
        const lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) =>
                product.estado === ProcessoNums.Disponible &&
                !product.vendido &&
                product.localizacion === localizador
        );

        const auth = "Basic " + btoa(this.CONSUMER_KEY + ":" + this.CONSUMER_SECRET);
        const datos_caja = this.generarDescripcionTabla(lista, 20);

        const body = {
            name: texto_caja,
            type: "simple",
            regular_price: datos_caja.precio_amazon_suma, // Precio original (antes del descuento)
            sale_price: datos_caja.precio_venta_suma, // Precio en oferta (actual
            description: datos_caja.descripcio,
            short_description: texto_caja + "con " + lista.length + " productos de " + categoria_seleccionada[0].name + " a un precio por unidad de " + (Number.parseFloat(datos_caja.precio_venta_suma) / lista.length).toFixed(2) + "€" + (pallet ? ". Palet de productos de Amazon con un peso total de " + pesoTotal + "kg" : ". Caja sin abrir, tal y como se recibe de Amazon."),
            categories: categoria_seleccionada,
            sku: localizador,
            stock_status: "instock",
            tags: [],
            images: [
                { src: `https://api.tiendadevoluciones.es/imagenes/1/${localizador}.png` }
                //
            ],
            manage_stock: true, // Habilita el seguimiento de inventario
            stock_quantity: 1,  // Establece la cantidad en stock
        };
        try {
            // console.log("Creando producto:", body);
            const response = await axios.post(url, body, {
                headers: {
                    Authorization: auth,
                    "Content-Type": "application/json",
                },
            });
        } catch (error) {
            console.error("Error al crear el producto:", error);
        }
    }

    generarDescripcionTabla(productos: ProductoAmazon[], porcentajePago: number) {
        productos.sort((a, b) => b.precio_amazon - a.precio_amazon);
        let tabla = ` <table border="1" cellspacing="0" cellpadding="5">
                        <thead>
                            <tr>
                            <th>AMAZON</th>
                            <th>Producto</th>
                            <th>PVP</th>
                            <th>PAGAS</th>
                            </tr>
                        </thead>
                        <tbody>`;
        let precio_venta_suma = 0;
        let precio_amazon_suma = 0;
        productos.forEach((producto) => {
            const pago = (producto.precio_amazon * porcentajePago) / 100;
            precio_venta_suma += pago;
            precio_amazon_suma += producto.precio_amazon;
            tabla += ` <tr>
                            <td><a href="${producto.link_amazon}">AMAZON</a></td>
                            <td>${producto.titulo_producto}</td>
                            <td>${producto.precio_amazon} €</td>
                            <td>${pago.toFixed(2)}</td>
                        </tr>
                     `;
        });

        tabla += `</tbody></table>`;

        return { descripcio: tabla, precio_venta_suma: precio_venta_suma.toFixed(2), precio_amazon_suma: precio_amazon_suma.toFixed(2) };
    }

    async obtenerCategorias(): Promise<any[]> {
        if (this.categorias.length > 0) {
            return this.categorias;
        }
        const url = this.API_URL + "products/categories";

        const auth = "Basic " + btoa(this.CONSUMER_KEY + ":" + this.CONSUMER_SECRET);

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: auth,
                    "Content-Type": "application/json",
                },
            });
            console.log("Categorías obtenidas con éxito:", response.data);
            this.categorias = response.data;
        } catch (error) {
            console.error("Error al obtener las categorías:", error);
        }
        return this.categorias;
    }
}

export default new TiendaService();
